export const changeLogs = [
  {
    id: 6,
    version: "2.18.0",
    date: "2025-10-06T00:00:00.000Z",
    title: "Introducing Wealth Series Core",
    description:
      "- Wealth Series Core features advanced AI-powered portfolios crafted for investors seeking lasting value through our most refined strategies.\n- Lock in your investment potential with our portfolios through annual, two-year, or even lifetime subscriptions.\n- Gain access to portfolios thoughtfully structured with an optimal number of stocks, balancing performance potential and ease of management.",
    category: ["ui_ux"],
    status: "released",
    tags: ["Wealth Series"],
  },
  {
    id: 5,
    version: "2.17.0",
    date: "2025-09-01T00:00:00.000Z",
    title: "New Launch: Crypto Obsidian & Wealth Series Improvement",
    description:
      "Crypto Obsidian\n- Introducing our newest product supporting Crypto and Futures trading, going live on September 8, 2025.\n- Gain access to expert-led livestreams and real-time alerts, backed by a transparent historical win log to boost your confidence.\n- Contact our sales team to find out more.\n\nWealth Series Improvement\n- We are always seeking to improve our AI models. Enjoy stronger, more diversified portfolios designed to deliver stronger performance.\n- Simplify your portfolio rebalance with Guided Rebalancing, a new tool aimed to help you calculate your adjustments effortlessly.",
    category: ["ui_ux"],
    status: "released",
    tags: ["Crypto Obsidian", "Wealth Series Premium"],
  },
  {
    id: 4,
    version: "2.16.0",
    date: "2025-06-02T00:00:00.000Z",
    title:
      "Auto Version for Wealth Series Now Live & Major Enhancements Released",
    description:
      "Wealth Series Auto Version\n- We are happy to announce that we are partnering with Orion to bring your Wealth Series portfolios to the next level!\n- With the Auto Version, portfolios are automatically rebalanced for you so that you can enjoy a hassle free experience with Wealth Series.\n- Contact our sales team to find out more.\n\nWealth Series Enhancements — Easier to Use, More to Discover\n- AI Trade Price: View the price at which AI-driven trades were executed during rebalancing.\n- Portfolio Narratives: Distinguish the narrative between portfolios and get an estimate on their average rebalance frequency.\n- Rebalance Rationale: Access the rationale behind each adjustment on the portfolio and ticker-level to better understand AI decision-making.\n- Portfolio Adjustments: Adjustments are now clearly categorized to show which tickers are set for an increase or decrease in allocation.\n- Ticker Performance: Analyze individual ticker performance and their contribution to your overall portfolio returns.\n- Benchmark Comparison: Compare your portfolio's performance against S&P500 for added context and perspective.\n\nLive Options Feed Enhancements — Faster, More Reliable, and Smarter\n- Improved Real-time Updates: Experience smoother, more reliable real-time updates with enhanced performance and reduced latency.\n- Smarter Filtering: New and improved filtering system for tickers, bid/ask prices, and contract quantities with instant results.\n- Infinite Scroll: Seamlessly load more options as you scroll, with intelligent caching for faster response times.\n- Enhanced URL Sharing: Share your filtered view with others through URL parameters that preserve your exact filter settings.\n- Better Performance: Optimized data handling and reduced memory usage for a smoother experience even with large datasets.\n\nTradeAlgo Sidebar Enhancements\n- Streamlined Product Grouping: Access Wealth Series, Terminal, and Options products in dedicated sections.\n- Subscribed Chips: Easily see and access your subscribed products at a glance.",
    category: ["ui_ux"],
    status: "released",
    tags: [
      "Wealth Series Auto",
      "Wealth Series Premium",
      "TradeAlgo",
      "Live Options",
    ],
  },
  {
    id: 3,
    version: "2.15.0",
    date: "2025-03-10T00:00:00.000Z",
    title: "Wealth Series Lite Now Available",
    description:
      "- Wealth Series Lite combines our AI stock picker model with a user-customizable portfolio that gamifies into a leaderboard stage across other subscribers.\n- Gain exclusive access to our AI stock picks, refreshed on a biweekly basis.\n- Contact our sales team to find out more.",
    category: ["ui_ux"],
    status: "released",
    tags: ["Wealth Series Lite"],
  },
  {
    id: 2,
    version: "2.14.0",
    date: "2025-02-03T00:00:00.000Z",
    title: "Introducing Wealth Series: Your Journey to Smarter Investments",
    description:
      "- Wealth Series is a new product on TradeAlgo allowing users to select from 3 tiers of AI-generated portfolio packs: Atlas, Titan, Everest.\n- Gain exclusive access to our investment strategy—such as high growth, low volatility, deep value, diversified, or balanced—we prioritize top stock picks using a sophisticated system of criteria to construct and maintain a well-optimized portfolio.\n- Contact our sales team to find out more.",
    category: ["ui_ux"],
    status: "released",
    tags: ["Wealth Series Premium"],
  },
  {
    id: 1,
    version: "2.13.0",
    date: "2025-01-06T00:00:00.000Z",
    title: " Introducing TradeGPT Trade Assistant",
    description:
      "- TradeGPT Trade Assistant is now available on all pages, to enhance your TradeAlgo experience.\n- TradeGPT Trade Assistant provides real-time insights, market analysis, and personalized responses to your trading queries.",
    category: ["ui_ux"],
    status: "released",
    tags: ["TradeGPT"],
  },
];
